<div class="loginContainer">
	<div class="containerInfo">
		<div class="productionLogikImage">
			<img src="/assets/img/production_logik.gif" alt="Production logik">
		</div>
		<a (click)="goToLogin()" class="loginlink">{{'Login with OKTA' | translate}}</a>
		<a [routerLink]="['/login_token']" class="loginlink">{{'Login with token' | translate}}</a>	
	</div>
</div>
